import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
  },
  viewerComponent: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "30px",
    height: "77%",
    minHeight: "500px",
    minWidth: "900px",
    width: "96%",
    position: "absolute",
    top: "4%",
    // left: "5%",
    zIndex: "1205",
    outline: "none",
  },
  leftButtonContainer: {
    position: "absolute",
    color: "green",
    top: "50%",
    left: "-50px",
  },
  rightButtonContainer: {
    position: "absolute",
    color: "green",
    top: "50%",
    right: "-50px",
  },
  leftOrRightButton: {
    padding: "0px",
    height: "100px",
    width: "50px",
    minWidth: "0px",
  },
  toolsContainer: {
    height: "72px",
    width: "100%",
    display: "flex",
    gap: "40px",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 30px",
    fontSize: "18px",
  },
  annotationButton: {
    minWidth: "0px",
    paddin: "5px",
  },
  iconStyle: {
    height: "30px",
    width: "30px",
  },
  closeButton: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    cursor: "pointer",
  },
  imageIconColor: {
    color: theme.palette.text.primary,
    fontSize: "21px",
    fontWeight: "bold",
  },
  modelViewerDiv: {
    width: "100%",
    position: "relative",
    height: "98%",
  },
  allowHrdChange: {
    position: "absolute",
    bottom: "0.1%",
    paddingLeft: "20px",
    width: "100%",
    height: "40px",
    boxShadow: "0 -10px 5px 1px rgba(0,0,0,0.45)",
    background: "rgba(0,0,0,0.45)",
    borderRadius: " 0 0 20px 20px",
  },
  notAllowed: {
    display: "none",
    position: "absolute",
    marginTop: "-50px",
    marginLeft: "20px",
  },
  imageDiv: {
    display: "flex",
    justifyContent: "space-between",
    marginRight: "10px",
    cursor: "pointer",
  },
  imageStyle: {
    height: "19.14px",
    width: "29.78px",
    marginTop: "2px",
  },
  downloadOption: {
    backgroundColor: "#1B1D28",
    padding: "5px",
    cursor: "pointer",
  },
  player: {
    height: "100%",
    width: "100%",
  },
  noFile: {
    display: "flex",
    justifyContent: "center",
  },
  versionSelector: {
    height: "130px",
    backgroundColor: "",
    minWidth: "900px",
    width: "100%",
  },
  closeFullScreen: {
    position: "absolute",
    top: "10px",
    right: "20px",
    cursor: "pointer",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    height: "30px",
    width: "30px",
  },
  modalCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  input: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    padding: "4px 10px",
    width: "160px",
  },
  menuItem: {
    backgroundColor: theme.palette.primary.main,
  },
  formControl: {
    alignItems: "center",
    justifyContent: "center",
    width: "150px",
    height: "40px",
    background: theme.palette.secondary.light,
    borderRadius: "10px",
  },

  dropdownDiv: {
    display: "flex",
    alignItems: "center",
    width: "150px",
    justifyContent: "space-between",
  },
  selectText: {
    marginLeft: "10px",
    fontFamily: "Poppins",
    fontSize: "14px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  arrowIcon: {
    marginRight: "10px",
    height: "20px",
    color: "white",
  },
  formLabelText: {
    height: "0%",
    width: "100%",
    opacity: "0",
    background: theme.palette.secondary.light,
  },
  dropDown: {
    backgroundColor: theme.palette.secondary.light,
    borderRadius: "10px",
    border: `1px solid ${theme.palette.text.tertiary}`,
    maxHeight: "200px",
    overflowY: "auto",
    marginTop: "35px",
    "& ul.MuiList-padding": {
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    "& li.MuiListItem-gutters": {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  emailText: {
    marginTop: "5px",
    color: "rgba(249, 249, 249, 0.6)",
    fontSize: "12px",
  },
  highlightedBtn: {
    color: "#F9F9F9",
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: "20px",
    padding: "6px 12px",
  },
  simpleBtn: {
    color: theme.palette.text.tertiary,
    border: `1px solid ${theme.palette.text.tertiary}`,
    borderRadius: "20px",
    padding: "6px 12px",
  },
  highlightedIcon: {
    color: theme.palette.secondary.main,
  },
  simpleIcon: {
    color: theme.palette.text.tertiary,
  },
}));

export default useStyles;
